import React from 'react';
import { translate } from 'react-i18next';
import classnames from 'classnames';

import { Form } from 'common/components';
const ReportsDepreciationFiltersButton = ({ setIsCollapsed, isCollapsed, t }) => {
  return (
    <div className="row">
      <Form.Button
        onClick={(e) => {
          e.preventDefault();
          setIsCollapsed(!isCollapsed);
        }}
        extraClassName="col-g btn btn-info ml-4 mr-4"
        text={`${
          isCollapsed
            ? t('reports.fields.buttonFilters.showFilters')
            : t('reports.fields.buttonFilters.hideFilters')
        }`}
      />
    </div>
  );
};

export default translate()(ReportsDepreciationFiltersButton);



// WEBPACK FOOTER //
// src/components/reports/depreciation/ReportsDepreciationFiltersButton.js